// extracted by mini-css-extract-plugin
export default {"Header":"tndconditions_Header__w90Yu","Content":"tndconditions_Content__aAqVH","Articulo":"tndconditions_Articulo__vQIN3","Bajada":"tndconditions_Bajada__eWasK"};